<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Company.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label><small class="text-danger">*</small> {{$lang.Company.LabelName}}:</label>
          <b-form-input type="text" v-model="form.nome.value" :maxlength="form.nome.maxlength" :required="form.nome.required" :state="form.nome.state" placeholder=""></b-form-input>
        </div>
        <div class="col-md-4">
          <label>Nome fantasia:</label>
          <b-form-input type="text" v-model="form.nomeFantasia.value" :maxlength="form.nomeFantasia.maxlength" :required="form.nomeFantasia.required" :state="form.nomeFantasia.state" placeholder=""></b-form-input>
        </div>
        <div class="col-md-2">
          <label><small class="text-danger">*</small> Código Z:</label>
          <b-form-input type="number" v-model="form.codigoZ.value" :disabled="editando" :state="form.codigoZ.state"></b-form-input>
        </div>
        <div class="col-md-2">
          <label>Localidade:</label>
          <b-form-input type="text" v-model="form.localidade.value" :maxlength="form.localidade.maxlength" :required="form.localidade.required" :state="form.localidade.state" placeholder=""></b-form-input>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3">
          <label>CNPJ:</label>
          <b-form-input type="text" v-model="form.cnpj.value" :maxlength="form.cnpj.maxlength" :required="form.cnpj.required" :state="form.cnpj.state" placeholder=""></b-form-input>
        </div>
        <div class="col-md-3">
          <label>IE:</label>
          <b-form-input type="text" v-model="form.ie.value" :maxlength="form.ie.maxlength" :required="form.ie.required" :state="form.ie.state" placeholder=""></b-form-input>
        </div>
        <div class="col-md-4">
          <label>Perfil de acesso (seletor do topo):</label>
          <b-form-select v-model="form.perfilAcessoID.value" :options="form.perfilAcessoID.options" :state="form.perfilAcessoID.state">
            <template slot="first">
              <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
            </template>
          </b-form-select>
        </div>
        <div class="col-md-2 d-flex align-items-end">
          <b-form-checkbox v-model="form.selecionavel.value" switch>Selecionável no topo</b-form-checkbox>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label>Logo:</label>
          <div class="d-flex align-items-center">
            <b-avatar v-if="logoURL" rounded="lg" :src="logoURL" size="6rem" class="mr-3" />
            <b-avatar v-else rounded="lg" variant="light" size="6rem" class="mr-3" text="—" />
            <div>
              <b-form-file accept="image/png,image/jpeg,image/webp,image/svg+xml" :disabled="enviandoLogo" placeholder="Escolher imagem (PNG, JPG, WEBP ou SVG até 1 MB)" browse-text="Enviar" @input="onLogoEscolhido"></b-form-file>
              <small class="small-help d-block mt-1"><i class="fa fa-info-circle"></i> <span v-if="form.logo.value">{{ form.logo.value }}</span><span v-else>Sem logo: o seletor mostra as iniciais do nome.</span></small>
              <b-button v-if="form.logo.value" size="sm" variant="link" class="p-0" @click="onLogoRemover">Remover logo</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtDescription"> {{$lang.Company.LabelDescription}}:</label>
          <b-form-textarea id="txtDescription"
                      name="txtDescription"
                      v-model="form.descricao.value"
                      :placeholder="$lang.Company.PlaceholderEnterDescription"
                      :rows="form.descricao.rows"
                      :maxlength="form.descricao.maxlength"
                      :noResize="form.descricao.noResize"></b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>

    <div class="form-group row">
      <div class="col-md-6">
        <b-form-input v-model="filtro.busca" type="search" placeholder="Pesquisar por nome, nome fantasia ou Código Z" debounce="400" @update="onFiltrar"></b-form-input>
      </div>
      <div class="col-md-2">
        <b-form-select v-model="filtro.selecionavel" :options="opcoesSelecionavel" @change="onFiltrar"></b-form-select>
      </div>
    </div>
    <Tables ref="tableGrid"
            :columns="[
              'Código Z',
              $lang.Company.DataTable.Name,
              'Nome fantasia',
              'Selecionável',
              $lang.Common.DataTable.Status,
              $lang.Common.DataTable.ActionDate,
              $lang.Common.DataTable.AccountAction,
              $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.codigoZ" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nome" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nomeFantasia" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.selecionavel ? 'Sim' : 'Não'" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataAcao" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nomeContaAcao" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>

  </div>
</template>

<script>
import Company from './company.js'

export default Company
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/company/company.vue